module.exports = __webpack_public_path__ + "assets/24612ff63fecb6c209d4aee23e88624f.png";